<template>
  <div class="menu-container">
    <div :class="{ 'mask': value }" @click="handleClickClose" />
    <div class="mune" :class="{ 'show-menu': value }">
      <div class="header">
        <div class="title">导航栏</div>
        <div class="right-close" @click="handleClickClose">✖</div>
      </div>
      <div class="option" v-for="item in menuOptions" :key="item.label">
        <div class="title">{{ item.label }}</div>
        <a
          class="item"
          v-for="children in item.children"
          :key="children.label"
          :href="children.href"
          @click="handleClickClose"
        >
          <div class="label">{{ children.label }}</div>
          <div class="arrow-right">﹥</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scrollTop: 0,
      menuOptions: [
        {
          label: '主页',
          children: [
            {
              label: '回首页',
              href: 'https://www.way-s.cn'
            }
          ]
        },
        {
          label: '关于威尔森',
          children: [
            {
              label: '了解威尔森',
              href: 'https://www.way-s.cn/About-WAYS.html'
            },
            {
              label: '企业文化',
              href: 'https://www.way-s.cn/Company-Culture.html'
            },
            {
              label: '威尔森观点',
              href: 'https://www.way-s.cn/news.html'
            },
            {
              label: '联系我们',
              href: 'https://www.way-s.cn/Contact-Us.html'
            }
          ]
        },
        {
          label: '产品',
          children: [
            {
              label: '智域',
              href: ''
            },
            {
              label: '智库',
              href: 'https://i.way-s.cn'
            },
            {
              label: '达示数据',
              href: 'http://www.daas-auto.com'
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleClickClose () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.menu-container {
  .mask {
    position: fixed;
    z-index: 99999999;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100vw;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .mune {
    transition: all 0.5s;
    position: fixed;
    z-index: 999999999;
    width: calc(100vw - 64px);
    top: 0;
    bottom: 0;
    right: calc(-100vw + 64px);
    max-height: 100%;
    overflow: auto;
    background-color: #fff;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 44px;
      padding: 0 12px;
      position: sticky;
      top: 0;
      background-color: #fff;
      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #161823;
        font-weight: 400;
      }
      .right-close {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #000;
        font-weight: 400;
      }
    }
    .option {
      padding: 0 12px;
      .title {
        padding: 12px 0;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        line-height: 16px;
        font-weight: 400;
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .label {
          padding: 12px 0;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #161823;
          line-height: 20px;
          font-weight: 400;
        }
        .arrow-right {
          font-size: 20px;
          color:  #CCCCCC;
        }
      }
    }
  }
  .show-menu {
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/menu.vue